export default "__VITE_ASSET__CNHiBKHJ__"